'use client';

import React, {
  PropsWithChildren,
  useMemo,
} from 'react';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import '@/config/datadogBrowserLogs';

export default function ReactQueryProvider({ children }: PropsWithChildren) {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 10 * 60 * 1000, // 10 minutes
            gcTime: 10 * 60 * 1000, // 10 minutes
            retry: false, // Disable retries for queries
          },
          mutations: {
            retry: false, // Disable retries for mutations
          },
        },
      }),
    [],
  );

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}